import { Store } from '@ngrx/store';

import { NotificationCommandProps } from '../../domain/models/notification.models';
import { NotificationCommandsFacade } from '../commands/notification.commands.facade';

export interface NotificationCommandsInterface {
    openNotification: (props: NotificationCommandProps) => void;
    closeNotification: () => void;
}

export function NotificationPublicPort(store: Store): NotificationCommandsInterface {
    const command = new NotificationCommandsFacade(store);
    return {
        openNotification: command.openNotification.bind(command),
        closeNotification: command.closeNotification.bind(command),
    };
}

export type PublicNotificationCommandProps = NotificationCommandProps;
